var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9125 5.0876C25.6761 4.85281 25.3794 4.68775 25.0553 4.61057C24.7311 4.53338 24.3919 4.54706 24.075 4.6501L5.78753 10.7501C5.44837 10.8576 5.14867 11.0631 4.92627 11.3408C4.70387 11.6185 4.56876 11.9559 4.53799 12.3104C4.50723 12.6648 4.5822 13.0204 4.75342 13.3323C4.92465 13.6442 5.18446 13.8983 5.50003 14.0626L13.0875 17.8126L16.8375 25.4251C16.9883 25.7231 17.2189 25.9732 17.5037 26.1476C17.7884 26.322 18.1161 26.4138 18.45 26.4126H18.575C18.9327 26.3863 19.2741 26.253 19.555 26.0301C19.8358 25.8071 20.0432 25.5049 20.15 25.1626L26.3375 6.9251C26.448 6.61001 26.4667 6.27003 26.3915 5.94472C26.3162 5.61941 26.1502 5.32217 25.9125 5.0876ZM6.56253 12.4751L22.525 7.1501L13.6625 16.0126L6.56253 12.4751ZM18.5375 24.4376L14.9875 17.3376L23.85 8.4751L18.5375 24.4376Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.a70d3dbddcb955f40f5578e6f6c1e443.svg";
export { ForwardRef as ReactComponent };